import { render, staticRenderFns } from "./ClientsGrille.vue?vue&type=template&id=a2478f2c&scoped=true&"
import script from "./ClientsGrille.vue?vue&type=script&lang=ts&"
export * from "./ClientsGrille.vue?vue&type=script&lang=ts&"
import style0 from "./ClientsGrille.vue?vue&type=style&index=0&id=a2478f2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2478f2c",
  null
  
)

export default component.exports